document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const supportEmail = 'support@shopsstop.com';
  const legacyEmails = ['shopsstop1@gmail.com', 'support@shopsspot.com'];

  const replaceSupportEmailReferences = () => {
    legacyEmails.forEach((legacyEmail) => {
      const escapedLegacyEmail = legacyEmail.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      document.querySelectorAll('a[href]').forEach((link) => {
        const href = link.getAttribute('href') || '';
        if (href.toLowerCase().includes(legacyEmail.toLowerCase())) {
          link.setAttribute('href', href.replace(new RegExp(escapedLegacyEmail, 'gi'), supportEmail));
        }
      });

      if (!document.body || !document.body.textContent.toLowerCase().includes(legacyEmail.toLowerCase())) return;
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => {
        if (node.nodeValue && node.nodeValue.toLowerCase().includes(legacyEmail.toLowerCase())) {
          node.nodeValue = node.nodeValue.replace(new RegExp(escapedLegacyEmail, 'gi'), supportEmail);
        }
      });
    });
  };

  replaceSupportEmailReferences();
  window.setTimeout(replaceSupportEmailReferences, 400);

  const formatDeliveryDate = (date) => {
    const locale = document.documentElement.lang || navigator.language || 'en-US';
    return new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' }).format(date);
  };

  const addBusinessDays = (date, days) => {
    const output = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    let added = 0;
    while (added < days) {
      output.setDate(output.getDate() + 1);
      const day = output.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return output;
  };

  const getDeliveryWindow = () => {
    const now = new Date();
    const start = addBusinessDays(now, 10);
    const end = addBusinessDays(now, 12);
    return `${formatDeliveryDate(start)} – ${formatDeliveryDate(end)}`;
  };

  const getDeliveryPropertyValue = () => `10–12 business days · ${getDeliveryWindow()}`;

  const updateDeliveryDates = () => {
    const windowText = getDeliveryWindow();
    document.querySelectorAll('[data-ss-delivery-date]').forEach((node) => {
      node.textContent = windowText;
    });
    document.querySelectorAll('[data-ss-delivery-property]').forEach((input) => {
      input.value = getDeliveryPropertyValue();
    });
  };

  const scheduleDeliveryDateRefresh = () => {
    const now = new Date();
    const nextMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 5);
    window.setTimeout(() => {
      updateDeliveryDates();
      scheduleDeliveryDateRefresh();
    }, Math.max(1000, nextMidnight.getTime() - now.getTime()));
  };

  updateDeliveryDates();
  scheduleDeliveryDateRefresh();

  const menuToggle = document.querySelector('[data-ss-menu-toggle]');
  const mobileMenu = document.querySelector('[data-ss-mobile-menu]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const expanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!expanded));
      mobileMenu.hidden = expanded;
      document.body.classList.toggle('menu-open', !expanded);
    });

    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        menuToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.hidden = true;
        document.body.classList.remove('menu-open');
      });
    });
  }

  document.querySelectorAll('[data-ss-buy-now]').forEach((button) => {
    button.addEventListener('click', async () => {
      if (button.disabled) return;
      const variantId = button.dataset.variantId;
      const quantityInput = button.dataset.qtyId ? document.getElementById(button.dataset.qtyId) : null;
      const quantity = Math.max(1, parseInt(quantityInput?.value || '1', 10) || 1);
      const originalText = button.textContent;
      const root = window.Shopify?.routes?.root || '/';

      button.disabled = true;
      button.textContent = 'Opening checkout…';

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity,
              properties: { 'Estimated delivery': getDeliveryPropertyValue() }
            }]
          })
        });
        if (!response.ok) throw new Error('Unable to add item to cart');
        window.location.href = `${root}checkout`;
      } catch (error) {
        console.error(error);
        button.disabled = false;
        button.textContent = originalText;
        const form = button.closest('.ss-product-info, .ss-home-hero__copy')?.querySelector('form');
        if (form) form.requestSubmit();
      }
    });
  });

  const gallery = document.querySelector('[data-ss-gallery]');
  if (gallery) {
    const mainImage = gallery.querySelector('[data-ss-main-image]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-ss-thumb]'));
    const prev = gallery.querySelector('[data-ss-gallery-prev]');
    const next = gallery.querySelector('[data-ss-gallery-next]');
    const counter = gallery.querySelector('[data-ss-gallery-counter]');
    const stage = gallery.querySelector('[data-ss-gallery-stage]');
    const expand = gallery.querySelector('[data-ss-expand]');
    const dialog = gallery.querySelector('[data-ss-lightbox]');
    const dialogImage = gallery.querySelector('[data-ss-lightbox-image]');
    const dialogClose = gallery.querySelector('[data-ss-lightbox-close]');
    let currentIndex = 0;

    const selectImage = (index) => {
      if (!thumbs.length || !mainImage) return;
      currentIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[currentIndex];
      const newSrc = thumb.dataset.src;
      const newAlt = thumb.dataset.alt || '';

      mainImage.classList.add('is-changing');
      window.setTimeout(() => {
        mainImage.src = newSrc;
        mainImage.alt = newAlt;
        if (dialogImage) {
          dialogImage.src = newSrc;
          dialogImage.alt = newAlt;
        }
        mainImage.classList.remove('is-changing');
      }, 90);

      thumbs.forEach((item, indexValue) => {
        const active = indexValue === currentIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (counter) counter.textContent = `${currentIndex + 1} / ${thumbs.length}`;
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => selectImage(index)));
    prev?.addEventListener('click', () => selectImage(currentIndex - 1));
    next?.addEventListener('click', () => selectImage(currentIndex + 1));

    stage?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') selectImage(currentIndex - 1);
      if (event.key === 'ArrowRight') selectImage(currentIndex + 1);
    });

    expand?.addEventListener('click', () => {
      if (!dialog || !mainImage || !dialogImage) return;
      dialogImage.src = mainImage.src;
      dialogImage.alt = mainImage.alt;
      if (typeof dialog.showModal === 'function') dialog.showModal();
    });

    dialogClose?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  }

  const stickyBuy = document.querySelector('[data-ss-sticky-buy]');
  const purchaseZone = document.querySelector('[data-ss-purchase-zone]');

  if (stickyBuy && purchaseZone && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        stickyBuy.classList.toggle('is-visible', show);
        stickyBuy.setAttribute('aria-hidden', show ? 'false' : 'true');
      },
      { threshold: 0.08 }
    );
    observer.observe(purchaseZone);
  }
});
